import { render, staticRenderFns } from "./InsightsChart.vue?vue&type=template&id=ba25b21a"
import script from "./InsightsChart.vue?vue&type=script&lang=js"
export * from "./InsightsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports